@if (loading) {
  <div class="catalog-container">
    <skeleton-body-text></skeleton-body-text>
    <skeleton-strategy-catalog></skeleton-strategy-catalog>
  </div>
} @else {
  @if (errorMessage) {
    <pdq-banner
      variant="danger"
      bannerTitle="Unable to Load Strategies"
      [content]="errorMessage"
      button="Retry"
      [closable]="false"
      (onButtonClick)="retryLoad()">
    </pdq-banner>
  }
  <ng-template #kpiList let-item="item">
    <div class="kpi-list">
      @for (kpi of item.parsedKpiTargets; track $index) {
        <p>{{ kpi }}</p>
      }
    </div>
  </ng-template>

  <ng-template #cardTemplate let-data>
    <div class="card-container">
      @for (item of data.strategyItems; track item[StrategyColumns.ID]) {
        <div
          class="card-body"
          [ngClass]="{ 'maxx-recommended-body': data.isMaxx }"
          (click)="navigateToStrategyDetails(item)">
          <div class="card-header">
            <div class="category-header">
              @if (data.isMaxx) {
                <div class="maxx-recommended">
                  <pdq-icon icon="pdqiq" size="small" color="raichu"></pdq-icon>
                  <span>MAXX Recommended for you</span>
                </div>
              }
              <p [ngClass]="optimizeCategoryName(item)">{{ item[StrategyColumns.PRIMARY_CATEGORY] }}</p>
              @if (item.isCustom) {
                <span class="custom-badge">Custom</span>
              }
              <div
                class="bookmark"
                [class.bookmark--active]="savedStrategyIds.has(item[StrategyColumns.ID])"
                (click)="toggleBookmark($event, item)">
                <pdq-button
                  [icon]="savedStrategyIds.has(item[StrategyColumns.ID]) ? 'bookmark-filled' : 'bookmark'"
                  iconColor="iris"
                  variant="ghost"
                  [plain]="true">
                </pdq-button>
              </div>
            </div>
            <h4 class="{{ data.isMaxx ? 'maxx-recommended-header' : '' }}">{{ item[StrategyColumns.NAME] }}</h4>
          </div>
          <div class="card-content">
            <p>
              {{ item[StrategyColumns.CONCEPT] }}
            </p>
          </div>
          <div class="kpi">
            <p class="title-text">Main KPIs:</p>
            <div [ngClass]="{ 'kpi-maxx': data.isMaxx }">
              <ng-container *ngTemplateOutlet="kpiList; context: { item: item }"></ng-container>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
  <div class="catalog-container">
    <div class="header-container">
      <div class="column left-header-container">
        @if (isEssentials) {
          <h1>Welcome back{{ userName ? ', ' + userName : '' }}</h1>
          <p>Increase AOV, drive repeat purchases, and fix post-purchase leaks with these recommended strategies</p>
        } @else {
          <h1>Proven Strategies to Win Every Checkout</h1>
          <p>
            Explore 150+ proven optimization strategies to improve your checkout experience, increase conversion rates,
            and drive more profits.
          </p>
        }
      </div>
      <div class="column right-header-container">
        @for (header of headersTexts; track header.id) {
          <div class="header-item">
            <div class="header-icon">
              <pdq-icon [icon]="header.icon" size="small" color="white"></pdq-icon>
            </div>
            <div class="header-text">
              <p>{{ header.id }}. {{ header.headerText }}</p>
              <p>{{ header.infoText }}</p>
            </div>
          </div>
        }
      </div>
    </div>
    @if (isEssentials && (loadingMaxStrategies || strategyItemsRecommendedByMaxx.length > 0)) {
      <div class="maxx-recommended-wrapper">
        <img
          class="maxx-shadow maxx-shadow--top"
          [class.maxx-shadow--visible]="!loadingMaxStrategies"
          src="assets/images/input-shadow.svg"
          alt="" />
        <img
          class="maxx-shadow maxx-shadow--bottom"
          [class.maxx-shadow--visible]="!loadingMaxStrategies"
          src="assets/images/input-shadow.svg"
          alt="" />
        <img
          class="maxx-shadow maxx-shadow--left"
          [class.maxx-shadow--visible]="!loadingMaxStrategies"
          src="assets/images/input-shadow.svg"
          alt="" />
        <img
          class="maxx-shadow maxx-shadow--right"
          [class.maxx-shadow--visible]="!loadingMaxStrategies"
          src="assets/images/input-shadow.svg"
          alt="" />
        <div class="maxx-recommended-section">
          <div class="maxx-recommended-top-row">
            <div class="maxx-recommended-header">
              <pdq-icon icon="pdqiq" size="small" color="raichu"></pdq-icon>
              <span>MAXX Recommended For You</span>
            </div>
            <div class="scroll-indicators">
              @for (item of strategyItemsRecommendedByMaxx; track item[StrategyColumns.ID]; let i = $index) {
                <span class="scroll-dot" [class.scroll-dot--active]="activeScrollIndex === i" (click)="scrollToCard(i)">
                </span>
              }
            </div>
          </div>
          <div class="maxx-scroll-container" #maxxScrollContainer (scroll)="onMaxxScroll()">
            @if (loadingMaxStrategies) {
              <skeleton-strategy-catalog [numOfCards]="3"></skeleton-strategy-catalog>
            } @else {
              @for (item of strategyItemsRecommendedByMaxx; track item[StrategyColumns.ID]) {
                <div class="maxx-card" (click)="navigateToStrategyDetails(item)">
                  <div class="card-header">
                    <p [ngClass]="optimizeCategoryName(item)">{{ item[StrategyColumns.PRIMARY_CATEGORY] }}</p>
                    <div class="maxx-card-actions">
                      <pdq-button
                        [icon]="savedStrategyIds.has(item[StrategyColumns.ID]) ? 'bookmark-filled' : 'bookmark'"
                        iconColor="iris"
                        variant="ghost"
                        [plain]="true"
                        (onClick)="toggleBookmark($event, item)">
                      </pdq-button>
                    </div>
                  </div>
                  <h4>{{ item[StrategyColumns.NAME] }}</h4>
                  <div class="card-content">
                    <p>{{ item[StrategyColumns.CONCEPT] }}</p>
                  </div>
                  <div class="kpi">
                    <p class="title-text">Main KPIs:</p>
                    <div class="kpi-list">
                      @for (kpi of item.parsedKpiTargets; track $index) {
                        <p>{{ kpi }}</p>
                      }
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>

      <div class="locked-catalog-wrapper">
        <h2 class="locked-catalog-title">Strategy Catalog</h2>
        <div class="locked-catalog-tabs">
          <pdq-tabs-group variant="underline">
            @for (tab of tabs; track tab) {
              <pdq-tab [value]="tab" [label]="tab" [active]="tab === currentCategory"></pdq-tab>
            }
          </pdq-tabs-group>
          <div class="locked-catalog-search">
            <pdq-input
              size="medium"
              background="light"
              placeholder="Search"
              [withIcon]="true"
              icon="search"></pdq-input>
            <pdq-button icon="fiter" label="Filter" variant="secondary"></pdq-button>
          </div>
        </div>
        <div class="locked-content-wrapper">
          <div class="locked-overlay">
            <pdq-button
              icon="lock"
              label="Unlock all strategies"
              variant="primary"
              (onClick)="openUpgradeDialog()"></pdq-button>
          </div>
          <div class="locked-content">
            <ng-container
              *ngTemplateOutlet="
                cardTemplate;
                context: { $implicit: { strategyItems: filteredStrategyItems.slice(0, 6), isMaxx: false } }
              "></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="max-container" [ngClass]="{ 'no-show': !shouldShowMaxxRecommendations }">
        <div class="max-cards">
          @if (loadingMaxStrategies) {
            <skeleton-strategy-catalog [numOfCards]="3"></skeleton-strategy-catalog>
          } @else {
            @if (shouldShowMaxxRecommendations) {
              <ng-container
                *ngTemplateOutlet="
                  cardTemplate;
                  context: { $implicit: { strategyItems: strategyItemsRecommendedByMaxx, isMaxx: true } }
                "></ng-container>
            }
          }
        </div>
      </div>
      <div class="head-tabs-row">
        <pdq-tabs-group variant="toggle" (onChange)="setCurrentHeadTab($event)">
          @for (tab of headerTabs; track $index) {
            <pdq-tab
              [value]="tab"
              [label]="tab === 'My Roadmap' ? 'My Roadmap (' + roadmapItems.length + ')' : tab"
              [active]="tab === currentHeadTab"
              [icon]="tab === 'My Roadmap' ? 'bookmark-filled' : undefined"
              iconColor="iris"></pdq-tab>
          }
        </pdq-tabs-group>
        <pdq-button
          icon="Plus"
          label="Custom Strategy"
          variant="primary"
          (onClick)="openCreateCustomStrategyDialog()"></pdq-button>
      </div>
      @if (currentHeadTab === headerTabs[0]) {
        <div class="filters-container">
          <div class="right-container">
            <pdq-input
              size="medium"
              background="light"
              placeholder="Search"
              [withIcon]="true"
              icon="search"
              [control]="strategySearchControl">
            </pdq-input>
            <pdq-button
              pdqPopover
              icon="fiter"
              [label]="filterText"
              variant="secondary"
              #filterPopoverRef="pdqPopover"
              [popoverTemplate]="filterPopover"
              [closeOnClickOutside]="true"
              forcePosition="bottom_right"></pdq-button>
            <ng-template #filterPopover>
              <pdq-popover-container [loading]="false">
                <div class="popover-container">
                  <div class="options-container">
                    <div class="option-list">
                      <p>KPI</p>
                      <pdq-input placeholder="Search" [withIcon]="true" icon="search" [control]="kpiSearchControl">
                      </pdq-input>
                      <pdq-options-list [options]="filteredKpiList" [multiple]="true"> </pdq-options-list>
                    </div>

                    <pdq-divider orientation="vertical"></pdq-divider>
                    <div class="option-list">
                      <p>Tags</p>
                      <pdq-input placeholder="Search" [withIcon]="true" icon="search" [control]="tagsSearchControl">
                      </pdq-input>
                      <pdq-options-list [options]="filteredTagsList" [multiple]="true"> </pdq-options-list>
                    </div>
                  </div>
                  <pdq-divider></pdq-divider>
                  <div class="apply-filter">
                    <pdq-button (onClick)="clearAllFilters()">Clear all</pdq-button>
                    <pdq-button (onClick)="applyFilters()" variant="dark">Apply</pdq-button>
                  </div>
                </div>
              </pdq-popover-container>
            </ng-template>
          </div>
          <pdq-tabs-group variant="underline" (onChange)="setCurrentCategory($event)">
            @for (tab of tabs; track tab) {
              <pdq-tab [value]="tab" [label]="tab" [active]="tab === currentCategory"></pdq-tab>
            }
          </pdq-tabs-group>
        </div>

        <ng-container
          *ngTemplateOutlet="
            cardTemplate;
            context: { $implicit: { strategyItems: filteredStrategyItems, isMaxx: false } }
          "></ng-container>
      } @else {
        <strategy-bookmarks
          [strategies]="roadmapItems"
          (strategiesChanged)="roadmapItems = $event"
          (strategyClicked)="navigateToStrategyDetails($event)"
          (strategyRemoved)="onStrategyRemovedFromRoadmap($event)">
        </strategy-bookmarks>
      }
    }
  </div>
}
